var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCount3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70876 32.5596C7.75678 29.3707 6.95395 25.6102 7.43351 21.9022C7.91307 18.1941 9.64618 14.7616 12.3452 12.1742C15.0443 9.58684 18.5469 8.0002 22.2719 7.67763C25.9968 7.35506 29.7201 8.31596 32.8237 10.4008C35.9274 12.4857 38.2248 15.5692 39.3346 19.1396C40.4445 22.71 40.3 26.5525 38.9253 30.0295C37.5505 33.5065 35.0282 36.4089 31.7768 38.2549C28.5254 40.1009 24.7405 40.7796 21.0503 40.1783",
    stroke: "#8CCE34",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7304 44.904L19.4962 40.437L23.7459 33.7552",
    stroke: "#8ECE30",
    strokeWidth: 2.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.459 29.2168C22.3523 29.2168 21.4123 29.0368 20.639 28.6768C19.8657 28.3168 19.279 27.8235 18.879 27.1968C18.4923 26.5702 18.2923 25.8568 18.279 25.0568L21.039 25.0568C21.079 25.4568 21.1657 25.7968 21.299 26.0768C21.4457 26.3435 21.6857 26.5502 22.019 26.6968C22.3657 26.8435 22.8523 26.9168 23.479 26.9168C24.3323 26.9168 24.9523 26.7302 25.339 26.3568C25.7257 25.9702 25.919 25.3768 25.919 24.5768C25.919 23.8168 25.699 23.2502 25.259 22.8768C24.8323 22.5035 24.2257 22.3168 23.439 22.3168L21.279 22.3168L21.279 20.5368L26.799 15.0568L26.799 17.1768L18.919 17.1768L18.919 14.8768L28.279 14.8768L28.299 16.7368L22.859 22.0568L22.819 20.1968C23.9123 20.1435 24.8257 20.2235 25.559 20.4368C26.3057 20.6502 26.899 20.9635 27.339 21.3768C27.7923 21.7902 28.1123 22.2768 28.299 22.8368C28.499 23.3835 28.599 23.9635 28.599 24.5768C28.599 25.5235 28.3857 26.3435 27.959 27.0368C27.5323 27.7302 26.9323 28.2702 26.159 28.6568C25.399 29.0302 24.499 29.2168 23.459 29.2168Z",
    fill: "#8CCE34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCount3);
export default __webpack_public_path__ + "static/media/count-3.af79d9713aa21f8330886f9a59b53440.svg";
export { ForwardRef as ReactComponent };